import { b } from '../../../lit-element.js';

const completeAnimation = b`
<svg id="refi-success" class="animate" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 130 130" aria-hidden="true">
            <line class="success-line-rt" x1="94.71" y1="16.76" x2="97.16" y2="7.56" fill="none" stroke="#59a545" stroke-linecap="round" stroke-linejoin="round" stroke-width="3.2"/>
            <line class="success-line-rc" x1="106.45" y1="23.55" x2="113.2" y2="16.83" fill="none" stroke="#59a545" stroke-linecap="round" stroke-linejoin="round" stroke-width="3.2"/>
            <line class="success-line-rb" x1="113.27" y1="35.32" x2="122.47" y2="32.85" fill="none" stroke="#59a545" stroke-linecap="round" stroke-linejoin="round" stroke-width="3.2"/>
            <line class="success-line-lb" x1="35.28" y1="113.23" x2="32.83" y2="122.43" fill="none" stroke="#59a545" stroke-linecap="round" stroke-linejoin="round" stroke-width="3.2"/>
            <line class="success-line-lc" x1="23.54" y1="106.44" x2="16.79" y2="113.15" fill="none" stroke="#59a545" stroke-linecap="round" stroke-linejoin="round" stroke-width="3.2"/>
            <line class="success-line-lt" x1="16.72" y1="94.66" x2="7.53" y2="97.13" fill="none" stroke="#59a545" stroke-linecap="round" stroke-linejoin="round" stroke-width="3.2"/>
            <circle class="success-circle" cx="65" cy="65" r="44.91" fill="#59a545" stroke-width="0"/>
            <polyline class="success-checkmark" points="42.63 67.18 57.34 81.89 86.54 52.69" fill="none" stroke="#ffffff" stroke-linecap="round" stroke-linejoin="round" stroke-width="10"/>

            <style>
            
            #refi-success {
                height: 14rem;
              }

              #refi-success .success-circle {
                transform: scale(0);
                transform-origin: 65px 65px;
              }
              #refi-success.animate .success-circle {
                animation: .5s circleGrow ease forwards;
              }

              #refi-success .success-checkmark {
                stroke-dasharray: 100;
                stroke-dashoffset: 100;
              }
              #refi-success.animate .success-checkmark {
                animation: .3s dash .4s linear forwards;
              }

              #refi-success .success-line-lb,
              #refi-success .success-line-lc,
              #refi-success .success-line-lt,
              #refi-success .success-line-rb,
              #refi-success .success-line-rc,
              #refi-success .success-line-rt {
                transform: scale(0);
                transform-origin: 65px 65px;
              }
              #refi-success.animate  .success-line-lb,
              #refi-success.animate  .success-line-lc,
              #refi-success.animate  .success-line-lt,
              #refi-success.animate  .success-line-rb,
              #refi-success.animate  .success-line-rc,
              #refi-success.animate  .success-line-rt {
                animation: .25s circleGrow ease forwards;
              }

              #refi-success.animate  .success-line-rt {
                animation-delay: .68s;
              }
              #refi-success.animate  .success-line-rc {
                animation-delay: .6s;
              }
              #refi-success.animate  .success-line-rb {
                animation-delay: .74s;
              }
              #refi-success.animate  .success-line-lt {
                animation-delay: .74s;
              }
              #refi-success.animate  .success-line-lc {
                animation-delay: .6s;
              }
              #refi-success.animate  .success-line-lb {
                animation-delay: .68s;
              }

              @keyframes circleGrow {
                0% {
                  transform: scale(0)
                }
                70% {
                  transform: scale(1.1)
                }
                100% {
                  transform: scale(1)
                }
              }

              @keyframes dash {
                to {
                  stroke-dashoffset: 0;
                }
              }
            </style>

          </svg>
`;

export { completeAnimation };
